import { WASM_TO_C_TYPE } from './LoweredEmitter';

// The wasm value-type encoding uses signed LEB negatives in some producers and the raw
// 0x7b-0x7f byte codes in others; map both to the internal type name.
const WASM_NUMERIC_TYPE_NAMES: Record<number, string> = {
  [-1]: 'i32', [-2]: 'i64', [-3]: 'f32', [-4]: 'f64', [-5]: 'v128',
  0x7f: 'i32', 0x7e: 'i64', 0x7d: 'f32', 0x7c: 'f64', 0x7b: 'v128',
};

// Renders a wasm value type (a numeric code, or a reference-type descriptor carrying a name)
// as its C equivalent (i32 -> int, f64 -> double, ...). Shared so function signatures, import
// prototypes, and global declarations all format types the same way.
export function wasmValueTypeToC(valueType: number | { name: string }): string {
  if (typeof valueType === 'object' && 'name' in valueType) {
    return WASM_TO_C_TYPE[valueType.name] || valueType.name;
  }
  const typeName = WASM_NUMERIC_TYPE_NAMES[valueType] || 'i32';
  return WASM_TO_C_TYPE[typeName] || typeName;
}
